import { useTemplatePlacementOptional } from '@/contexts/template-placement-context'

/**
 * The drag-over state for a template drag (US-13): while a template is dragged over the spread,
 * the document takes a visible tint and outline marking it as a valid drop target. Nothing is
 * rendered otherwise. It sits above the shapes but ignores the pointer, so it never changes what a
 * drop hits. The z-index only has to clear the shapes' own, which count up from 1 with the number
 * of elements on the spread.
 */
export function TemplateDropOverlay() {
  const placement = useTemplatePlacementOptional()

  if (!placement?.isOverDropSurface) return null

  return (
    <div
      data-testid="template-drop-overlay"
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 z-[100000] bg-primary/10 ring-2 ring-inset ring-primary/60"
    />
  )
}
